'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Be sure to update feed-consumer i18n.json when adding or changing keys

var autoplayOff = 'feed.community-player.autoplay_off';
var autoplayOn = 'feed.community-player.autoplay_on';
var viewNext = 'feed.community-player.view_next';
var viewPrevious = 'feed.community-player.view_previous';
var highlightRendering = 'feed.highlight-feed-item.rendering';

exports.default = {
  autoplayOff: autoplayOff,
  autoplayOn: autoplayOn,
  viewNext: viewNext,
  viewPrevious: viewPrevious,
  highlightRendering: highlightRendering
};